import { Pipe, PipeTransform } from '@angular/core';
import { InstallerResponse, MatchedInstaller } from '~gc/domains/work/matched-installer/matched-installer.model';

@Pipe({ name: 'isPendingResponse' })
export class IsPendingResponsePipe implements PipeTransform {
  transform(matchedInstaller: MatchedInstaller): boolean {
    return matchedInstaller?.response === InstallerResponse.Pending;
  }
}
